import { MessagingTopology } from '@internal/open-catalog';
import React, { ChangeEvent, useState } from 'react';
import { InputSourcePanel } from './panel.input.source';
import { InputTargetPanel } from './panel.input.target';
import { MessagingNodeData } from '../flow';
import { SelectedPanel } from './panel.selected';

export function InputToolbar(props: {
  data: MessagingNodeData,
  topology: MessagingTopology,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { data, topology, onTopologyChange } = props;

  const [expanded, setExpanded] = useState<string>('sources');

  const handleAccordionStateChange = (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (<>
    <SelectedPanel data={data} icon={data.icon} />
    <InputSourcePanel
      topology={topology}
      expanded={expanded}
      onAccordionStateChange={handleAccordionStateChange}
      onTopologyChange={onTopologyChange} />
    <InputTargetPanel 
      topology={topology}
      expanded={expanded}
      onAccordionStateChange={handleAccordionStateChange}
      onTopologyChange={onTopologyChange} />
  </>);
}